import { render, staticRenderFns } from "./sjjy1.vue?vue&type=template&id=6b023099&scoped=true&"
import script from "./sjjy1.vue?vue&type=script&lang=js&"
export * from "./sjjy1.vue?vue&type=script&lang=js&"
import style0 from "./sjjy1.vue?vue&type=style&index=0&id=6b023099&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b023099",
  null
  
)

export default component.exports